import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { DataService } from 'src/app/Common/data.service';
import { CommonService } from 'src/app/shared/common.service';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { FileUploadComponent } from 'src/app/out-of-application/file-upload/file-upload.component'
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import saveAs from 'file-saver';
import { Editor } from 'ngx-editor';
export interface DialogData {
  ID: string;
}
@Component({
  selector: 'app-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.scss'],
  //providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService]
})
export class MailTemplateComponent implements OnInit {
  editor: Editor | undefined;
  // public tools: object = {
  //   items: [
  //     'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
  //     'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
  //     'LowerCase', 'UpperCase', '|', 'Undo', 'Redo', '|',
  //     'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
  //     'Indent', 'Outdent', '|', 'CreateLink', 'CreateTable',
  //     'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  // };

  editorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '150px',
    placeholder: 'Enter text here...',
    width: '100%'
  };

  mailStatusList: any;
  MailTemplateForm: UntypedFormGroup;
  employeeListTO: any[] = [];
  employeeListCC: any[] = [];
  employeeListBCC: any[] = [];
  filterList: any;
  LocalAttachments: any;
  RequestEntityId: string;
  FileUploadDialogRef: MatDialogRef<FileUploadComponent>;

  constructor(private _fb: UntypedFormBuilder, public dialogRef: MatDialogRef<MailTemplateComponent>, private _dialog: MatDialog,
    private _dataService: DataService, public _commonService: CommonService, private error: AppErrorHandler,
    @Inject(MAT_DIALOG_DATA) public _data: DialogData, private status: HTTPStatus, private _serviceRequestService: ServiceRequestService) { }

  ngOnInit() {
    this.editor = new Editor();
    this.BindStatusList();
    this.MailTemplateForm = this._fb.group({
      RequestEntityId: [],
      MailToEmail: ["", ""],
      MailCC: [""],
      MailBCC: [""],
      Subject: [],
      Body: [""],
      MailTemplateName: [''],
      MailTo: [""],
      MailCCEmail: ["", ""],
      MailBCCEmail: ["", ""],
      MailAttachment: []


    });
    this.GetMailTemplateForSR(this._data.ID);
    this.RequestEntityId = this._data.ID;
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
  BindStatusList() {
    this._commonService.BindDropDown('MailStatus').subscribe(result => {
      this.mailStatusList = result;
    });
  }
  SearchActiveEmployee = (event, type) => {
    this._commonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      if (type = "TO") {
        this.employeeListTO = this.filterDataList(event.query, result);
      }
      if (type = "CC") {
        this.employeeListCC = this.filterDataList(event.query, result);
      }
      if (type = "BCC") {
        this.employeeListBCC = this.filterDataList(event.query, result);
      }
    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }
  SetEmployeeDetailsTo(event) {
    this.MailTemplateForm.patchValue(
      {
        MailTo: this.MailTemplateForm.controls.MailTo.value + ';' + event.EmpEmail
      })
  }
  SetEmployeeDetailsCC(event) {
    this.MailTemplateForm.patchValue(
      {
        MailCC: this.MailTemplateForm.controls.MailCC.value + ';' + event.EmpEmail
      })
  }
  SetEmployeeDetailsBCC(event) {
    this.MailTemplateForm.patchValue(
      {
        MailBCC: this.MailTemplateForm.controls.MailBCC.value + ';' + event.EmpEmail
      })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  GetMailTemplateForSR(ID: string) {
    this._serviceRequestService.GetMailTemplateForSR(ID, '', this.MailTemplateForm.controls.MailTemplateName.value).subscribe(data => {
      this.MailTemplateForm.patchValue(data);
      this.employeeListTO = [{
        EmpEmail: data.MailTo
      }];
      if (data.MailCC != "") {
        this.employeeListCC = [{
          EmpEmail: data.MailCC
        }];
        this.MailTemplateForm.controls.MailCCEmail.setValue(this.employeeListCC);
        this.MailTemplateForm.controls.MailCC.setValue(data.MailCC);
      }
      this.MailTemplateForm.controls.RequestEntityId.setValue(this._data.ID);
      this.MailTemplateForm.controls.MailToEmail.setValue(this.employeeListTO);
      this.MailTemplateForm.controls.MailTo.setValue(data.MailTo);


      //this.MailTemplateForm.controls.MailTo.setValue(data.MailTo)

      this.MailTemplateForm.controls.Body.setValue(data.Body);
      this.MailTemplateForm.controls.Subject.setValue(data.Subject);

    }
      , (error) => {
        //this.status.setHttpStatus(false);
        this.error.handleError(error);
      }, () => {
        //this.status.setHttpStatus(false); 
      });
  }
  openFileUploadDialog() {
    this.FileUploadDialogRef = this._dialog.open(FileUploadComponent,
      {
        disableClose: true,
        width: '50%',
        data: { ID: this._data.ID, AttachmentFor: "Mailer", LocalAttachments: this.LocalAttachments }
      });
    this.FileUploadDialogRef.afterClosed().subscribe(result => {
      this.LocalAttachments = result;
      this.FileUploadDialogRef = this._dialog.open(FileUploadComponent,
        {
          disableClose: true,
          width: '50%',
          data: { ID: this._data.ID, AttachmentFor: "Mailer", LocalAttachments: this.LocalAttachments }

        });

    })

  }
  SendMail() {
    this.status.setHttpStatus(true);
    this.MailTemplateForm.controls.RequestEntityId.setValue(this._data.ID);
    this.MailTemplateForm.controls.MailAttachment.setValue(this.LocalAttachments);
    this._commonService.SendMail(this.MailTemplateForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {
        if (data.RequestEntityId !== null) {
          this.dialogRef.close();
        }
      } else {
        // this.alertService.notify('warn', 'warn!', data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }
  DownloadFile(attachmentData) {
    const downloadURL = 'Attachment/DownLoadFile';
    this._dataService.PostDownload(downloadURL, attachmentData).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, attachmentData.AttachmentName);
    });
  }
}
